$(document).ready(function () {

  var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight){
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }


  $('.js-slider').owlCarousel({
    loop: true,
    margin: 0,
    nav: true,
    dots: true,
    items: 1,
    mouseDrag:false,
    autoplay: true,
    autoplayTimeout: 7000,
    smartSpeed: 1000,
    animateIn:'fadeInRight',
    animateOut: 'fadeOutLeft',
    navText: ["<span class='prev iconFont iconFont--smallx'></span>","<span class='next iconFont iconFont--smallx'></span>"]
  });


  var player = new Plyr('#player', { controls: ['play', 'progress', 'mute','volume'] });

  var supported = Plyr.supported('video', 'html5', true);


  //slider video
  var sourceAdded = false;
  var isMobile = false;
  function addSourceToVideo() {

    var screenWidth = $(window).width();
    isMobile = screenWidth <= 900;

    if (screenWidth > 900 && !sourceAdded) {

      var sourceElement = $('<source>').attr({
        src: '/images/banner.mp4',
        type: 'video/mp4'
      });

      $('#player').append(sourceElement).removeClass('mobile');
      $('.slider').removeClass('slider--mobile');
      sourceAdded = true;
    } else if (isMobile && !sourceAdded) {
      var mobileSourceElement = $('<source>').attr({
        src: '/images/banner-mobile.mp4',
        type: 'video/mp4'
      });

      $('#player').append(mobileSourceElement).addClass('mobile');
      $('.slider').addClass('slider--mobile');
      sourceAdded = true;
    } else if (!isMobile && sourceAdded) {
      $('#player source').remove();
      sourceAdded = false;
    }
  }

  $(window).on('load resize', addSourceToVideo);



  window.scrollTo(0,0);

  $('.js-openMenuRight').on('click', function() {
    $(this).toggleClass('active');
    $('.header__right').toggleClass('active');
    $('.rightMenu').animate({width: 'toggle'}, 700);
    $('body').addClass('opacity');
  });

  $('.js-closeMenuRight').on("click", function () {
    $('.header__right').removeClass('active');
    $('.rightMenu').animate({width: 'toggle'}, 700);
    $('body').removeClass('opacity');
  });

  AOS.init({ disable: function() {
      var maxWidth = 900;
      return window.innerWidth < maxWidth;
    }});

  $(window).scroll(function(){
    if($(window).scrollTop() > 65 ) {
      $(".header").addClass('header--scroll');
    } else {
      $(".header").removeClass('header--scroll');
    }
  });


  document.querySelectorAll('.mainContainer__offer-single .module').forEach(function(el, i) {
    el.classList.remove('module');
    el.classList.add('single__module');
  });

  document.querySelectorAll('.offerSingleDetails__slider .slick-arrow').forEach(function(el, i) {
    el.innerHTML = '';
  });

  $('.offerSingleDetails__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
    asNavFor: '.offerSingleDetails__nav'
  });
  $('.offerSingleDetails__nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.offerSingleDetails__slider',
    focusOnSelect: true
  });

  $('.modules__inner.owl-carousel').owlCarousel({
    items: 1,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    mouseDrag: true,
    margin: 25,
    responsive: {
      1024: {
        items: 5
      }
    }
  });


  // $('[data-front-slider]').slick({
  //   dots: true,
  //   infinite: true,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   speed: 1000,
  //   fade: true,
  //   useTransform: true,
  //   // cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  //   adaptiveHeight: true,
  //   appendArrows: $('.sliderHome__nav'),
  //   prevArrow: '<button type="button" class="slick-prev"></button>',
  //   nextArrow: '<button type="button" class="slick-next"></button>'
  // });


  // var wow = new WOW();
  // wow.init();


  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax', {
      center: true
    });
  }

  $(".sliderOwl__arrowDown").on("click", function (e) {
    e.preventDefault();
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.intro').offset().top - 100
    }, 1500, 'swing');
  });

  $('#arrowMap').on('click', function() {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.contactPlaceMap').offset().top - 200
    }, 1500, 'swing');
  });

	var hash= window.location.hash;

	// if ( hash == '' || hash == '#' || hash == undefined ) return false;


	      var target = $(hash);

				// console.log(target);

	      headerHeight = 120;
	      // target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				// console.log(hash);

				if (target.length) {
	        $('html,body').stop().animate({
	          scrollTop: target.offset().top - 125 //offsets for fixed header
	        }, 'linear');
	      }

  //initialize paroller.js
  $('.contentHome__women').paroller();

    if(top.location.href.indexOf("?sideform")!==-1){
      if ($('.formErrors__item--menu').hasClass("error")) {
        alert('1');
        $('.rightMenu').css('display', 'block');
        $('.header__right').addClass('active');
        $('body').addClass('opacity');
      }
      if ($('.formErrors__item--menu').hasClass("success")) {
        $('.rightMenu').css('display', 'block');
        $('.header__right').addClass('active');
        $('body').addClass('opacity');
      }
    }


    if(top.location.href.indexOf("?footerform")!==-1){
      if ( $('.formErrors__item').length ) {
        $('html, body').animate({
          scrollTop:  $('.footer__center').offset().top - 200
        }, 600);
      }
    }

  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

});

$("img").each(function () {
  if ($(this).css("float") == "left") { $(this).addClass("imgLeft"); }
  if ($(this).css("float") == "right") { $(this).addClass("imgRight"); }
});

function scroll(e) {

  var href = $(this).attr('href');

  e.preventDefault();

  $('html, body').animate({
    scrollTop: $(href).offset().top - 200
  }, 1500);

  location.hash = href;

};


$('a[href*="#"].contactBoxes__link--form').click(scroll);
